import { ref } from 'vue';

const GET_PRODUCTS_URL = 'https://us-central1-trendztube.cloudfunctions.net/getProducts'; // Use your deployed function URL

export function useLemonSqueezy() {
  const loading = ref(false);
  const error = ref(null);

  // Fetch products with their variants/plans from backend
  const fetchProductsWithPlans = async () => {
    loading.value = true;
    error.value = null;
    try {
      console.log('[LemonSqueezy] Fetching products from backend...');
      const response = await fetch(GET_PRODUCTS_URL, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch products');
      }
      console.log('[LemonSqueezy] Products fetched:', result.data);
      return result.data;
    } catch (err) {
      error.value = err.message;
      console.error('[LemonSqueezy] Error fetching products:', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  // Legacy method for compatibility
  const fetchProducts = async () => {
    const productsWithPlans = await fetchProductsWithPlans();
    return productsWithPlans;
  };

  // Legacy method for compatibility
  const fetchPlans = async () => {
    const productsWithPlans = await fetchProductsWithPlans();
    // Extract all variants from all products
    return productsWithPlans.flatMap(product => product.variants || []);
  };

  // Format price for display
  const formatPrice = (price, currency = 'USD') => {
    if (!price) return 'Free';
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(price / 100); // Lemon Squeezy prices are in cents
  };

  // No need to validate setup on frontend anymore
  const validateSetup = () => {
    return true;
  };

  return {
    loading,
    error,
    fetchProducts,
    fetchPlans,
    fetchProductsWithPlans,
    formatPrice,
    validateSetup
  };
}
